/* global modForm */
/**
 * Populate form input
 * @param {String} name - name of a field
 * @param {String} value - value of a field
 */
export function populateInput(name, value) {
	const $form = modForm.opts.form;
	const $fields = $form.querySelectorAll('input[name="' + name + '"], select[name="' + name + '"]');

	if (!$fields.length) {
		return;
	}

	$fields.forEach(function($field) {
		if ('INPUT' === $field.tagName && 'radio' === $field.type && $field.value === value) {
			$field.checked = true;
		} else if ('INPUT' === $field.tagName && 'checkbox' === $field.type && $field.value === value) {
			$field.checked = true;
		} else if ('select-one' === $field.type) {
			if ($field.options && $field.options.length) {
				for (const $option of $field.options) {
					if ($option.value === value) {
						$field.value = value;
						break;
					}
				}
			}
		} else if (!['radio', 'checkbox', 'select-one'].includes($field.type)) {
			$field.value = value;
			if (name === 'zip') {
				const $zip1 = $form.querySelector('input[name="zip1"]');
				if ($zip1) {
					$zip1.value = value;
				}
			}
		}
	});
}
